import TextBox from 'admin/components/atoms/TextBox';
import { Item, Label, LabeledTable as Table, Row } from 'admin/components/molecules/LabeledTable';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import DateTime from '../../../atoms/DateTime';
import TextArea from '../../../atoms/TextArea';

const StyledTextBox = styled(TextBox)`
  width: 750px;
  display: block;
`;
const StyledTextArea = styled(TextArea)`
  width: 750px;
  display: block;
`;

const DateTimeWrapper = styled.div`
  width: 250px;
  ${DateTime} {
    margin-bottom: 0;
  }
`;

const MessageComposeForm = () => {
  const { register, control, watch } = useFormContext();
  return (
    <Table>
      <Row>
        <Label required htmlFor="subject">
          件名
        </Label>
        <Item>
          <StyledTextBox
            required
            placeholder="24字以内"
            maxLength={24}
            {...register('subject', { required: true })}
          />
        </Item>
      </Row>
      <Row>
        <Label required htmlFor="message">
          本文
        </Label>
        <Item>
          <StyledTextArea
            required
            placeholder="64字以内"
            maxLength={64}
            {...register('message', { required: true })}
          />
        </Item>
      </Row>
      <Row>
        <Label htmlFor="scheduled_at">配信希望日時</Label>
        <Item>
          <DateTimeWrapper>
            <Controller
              name="scheduled_at"
              control={control}
              render={({ field: { onChange } }) => (
                <DateTime
                  showIcon
                  isValidDate={(d) => d.isAfter(new Date())}
                  locale="ja-JP"
                  timeFormat="HH:mm:ss"
                  onChange={onChange}
                  value={watch('scheduled_at')}
                />
              )}
            />
          </DateTimeWrapper>
        </Item>
      </Row>
    </Table>
  );
};

export default MessageComposeForm;
